<template>
    <div class="spring">
        <h1 class="heading heading--4 heading--light heading--leading heading--center gutter--bottom">Extraopțiuni cartela în roaming</h1>
        <div class="js-component-component component__component">
            <div class="carousel__slide bundle__container"
                v-for="(offer, index) in offers" :key="index"
            >
                <div class="bundle offers-postpaid-cards">
                
                    <h3 class="visually-hidden">Ofertă</h3>
                    <div class="bundle__summary list--overflow">
                        <p class="bundle-price gutter--top">
                            <span class="visually-hidden">Costul pachetului</span>
                            <span>
                                <strong class="bundle-price__cost">
                                    {{ offer.offerPrice }}&euro;
                                    <span class="heading--4 heading--light heading--leading heading--trailing">credit</span>
                                </strong>
                            </span>
                            <div>
                                Valabila {{ offer.offerValability }} de zile
                            </div>
                        </p>
                    </div>
                    <div data-js="_accordion" data-classes="active=show-more__heading--active" class="js-accordion show-more">
                        <div class="js-accordion-content show-more__content">
                            <p class="visually-hidden">Include</p>
                            <ul class="list list--reset bundle__inclusions">                                
                                <li class="bundle__inclusion bundle__inclusion--icons flush--top grey--small-text">Beneficii incluse în extraopțiune</li>

                                <li class="bundle__inclusion bundle__inclusion--icons flush--top"
                                    v-for="(offerBenefit, index) in offer.offerBenefits" :key="index"
                                >
                                    <span class="offers-icon-list offers-icon-list--wifi">
                                        <img class="offers-icon_img" 
                                            :src="`https://static.vodafone.ro/roaming/images/${offerBenefit.icon}.png`"
                                        >
                                    </span>
                                    <span v-html="offerBenefit.label"></span>
                                </li>
                            </ul>
                            <p class="cards-bottom--disclaimer text-left">
                                <ul class="list list--reset bundle__inclusions" style="list-style-type: disc;padding-left: 20px;margin: 10px 0;"
                                    v-for="(offerConsumable, index) in offer.offerConsumables" :key="index"
                                >
                                    <li v-html="offerConsumable.label"></li>
                                </ul>
                            </p>
                        </div>
                    </div>
                    <div class="bundle__select bundle__select--first gutter--top">
                        <a 
                            @click="trackingButton" 
                            :href="offer.offerButtonLink" 
                            rel="noopener noreferrer"
                            class="button button--secondary button--full-width"
                        >
                            Activează
                        </a>
                    </div>
                    <span class="bundle__disclaimer--text">
                        Activează oferta direct din contul <strong>My Vodafone</strong> sau la <strong>*100#</strong>.
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            offers: {
                type: Array,
                required: true
            },
            selectedCountry: {
                type: Object,
                required: true
            }
        },
        methods: {
            trackingButton() {
                dataLayer.push({
                    "event": "microData",
                    "event_name": "action_click",
                    "click_element_name": `Activeaza - Prepaid ${this.selectedCountry.name}`,
                    "page_name":"roaming"
                });
            }
        }
    }
</script>